import React, { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import Table from "../../../components/Table/Table";
import { Dimmer } from "semantic-ui-react";
import { isEditActiveSelector } from "../../../reducers/editReducer";
import * as _ from "lodash";
import EditDataActCodeCommon from "../../Editing/EditDataActCodeCommon";
import { Filter } from "../../../components/Table/Migration/LegacyTypes";
import { editActions } from "../../../actions/editActions";
import { pdApiActions } from "../../../actions/pdApiActions";


interface DataActProps {
  columns: State.ColumnMap;
  subMenuRoute: string;
  setColumnFilters: (subMenuRoute: string, columnFilter: Filter[]) => void;
  editActions: typeof editActions;
  editedObjectId: number | undefined;
  toggleModal: () => void;
}

const DataAct: React.FC<DataActProps> = props => {
  const dispatch = useDispatch();
  const pdApi = useSelector((state: State.Root) => state.pdApi);
  const isLoading = useSelector((state: State.Root) => state.loadingStatus.isDataActCodesLoading);
  const isEditActive = useSelector((state: State.Root) => isEditActiveSelector(state.editView));
  const mainState = useSelector((state: State.Root) => state.main);
  const selectedColumns = props.columns["Data Act"];
  const handleFilterChangeDebounced = useCallback(
    _.debounce((changedFilters: Filter[]) => {
      props.setColumnFilters(props.subMenuRoute, changedFilters);
    }, 500),
    [props.setColumnFilters, props.subMenuRoute]
  );
  useEffect(() => () => handleFilterChangeDebounced.cancel(), [handleFilterChangeDebounced]);
    useEffect(() => {
      /*if (pdApi["dataActCodes"] === undefined) {
        dispatch(pdApiActions.fetchDataActCodes());
      }
      if(pdApi.liftFaults === undefined) {
        dispatch(pdApiActions.fetchLiftFaults());
      }*/
     dispatch(pdApiActions.fetchDataActCodes());
     dispatch(pdApiActions.fetchLiftFaults());
     dispatch(pdApiActions.fetchAPMFaults());
    }, [dispatch]);
  const isSelected = useCallback(
    (dataAct: Api.DataActCode): boolean => props.editedObjectId === dataAct.id,
    [props.editedObjectId]
  );
  return (
    <div className="flex-1">
      <div className="flex-1">
        <Table
          startingPage={0}
          rows={pdApi.dataActCodes ? pdApi.dataActCodes : []}
          loading={isLoading}
          loadingText="Fetching Data Act codes"
          columns={selectedColumns}
          isHidingTextActive={mainState.isShortenTextEnabled}
          handleRowSelection={row => dispatch(editActions.select(row))}
          isRowSelected={isSelected}
          pageSize={mainState.pageSize}
          handleFilterChange={handleFilterChangeDebounced}
        />
      </div>
      {isEditActive && (
        <Dimmer active={true} page={true}>
          <div
            className="edit-view"
            style={{
              flex: mainState.editSize,
              width: mainState.editSize == 0.3 ? "500px" : "1000px"
            }}
          >
            <EditDataActCodeCommon toggleModal={props.toggleModal} target="Lift" />
          </div>
        </Dimmer>
      )}
    </div>
  );
};

export default DataAct;
